import React from 'react'

import SgIcon from "./icons/domino/sg_icon";

const Sg = ({item, startsignal, onClick, lcs}) => {

    function handleClick(e) {
        let cc = {id: item.id, cl: e}
        onClick(cc);
    }

    var stbitem = lcs && lcs.find((itm) => {
        return itm.id === item.streckenblock;
    });

    return (
        <SgIcon item={item} startsignal={startsignal} stbitem={stbitem} onClick={handleClick}/>
    )
}

export default Sg

